import { SkanetrafikenAction } from './actions';

export interface ISkanetrafiken {
  isFetching: boolean;
  isFetchFailed: boolean;
  locationOptions: Julius.Website.SkanetrafikenPoint[];
  travelOptions: Julius.Website.TravelDataViewModel;
}

const initialSkanetrafikenState: ISkanetrafiken = {
  isFetching: false,
  isFetchFailed: false,
  locationOptions: [],
  travelOptions: null,
};

function skanetrafiken( 
  state: ISkanetrafiken = initialSkanetrafikenState, 
  action: SkanetrafikenAction,
): ISkanetrafiken {

  switch (action.type) {
    case 'SET_LOCATION_POINTS':
      return {
        ...state,
        locationOptions: action.points,
      };

    case 'SET_TRAVEL_OPTIONS':
      return {
        ...state,
        isFetching: false,
        isFetchFailed: false,
        travelOptions: action.options,
        locationOptions: [],
      };

    case 'SET_IS_FETCHING_TRAVEL_OPTIONS':
      return {
        ...state,
        isFetching: true,
        isFetchFailed: false,
      };

    case 'SET_FETCH_TRAVEL_OPTIONS_FAILED': 
      return {
        ...state,
        isFetching: false,
        isFetchFailed: true,
      };

    case 'CLEAR_SKANETRAFIKEN_CONTENT':
      return initialSkanetrafikenState;

    default: return state;
  }
}

export default skanetrafiken;


// WEBPACK FOOTER //
// ./src/components/PickSkanetrafiken/Redux/reducer.tsx